export enum Status {
  OK = 0,
  MERGED = 1,
  INVALID = 2,
  DELETED = 3,
  DUPLICATE = 4,
  HAS_DUPLICATES = 5,
  HIDDEN = 6
}
